// Small helper: returns the CSS class for the current seasonal theme, or ''.
// Themes are added to <body> so they can layer over the whole app.
//   - weekend: Fri/Sat/Sun → chase lights strip
//   - xmas: Dec 1 – Jan 6 → falling snowflakes
//   - halloween: Oct 24 – Nov 1 → cobwebs & pumpkin corner
export function currentSeasonClass(now = new Date()) {
  try {
    const preview = localStorage.getItem('ww_season_preview');
    if (preview === 'xmas' || preview === 'halloween') return `season-${preview}`;
  } catch { /* storage unavailable */ }
  const month = now.getMonth() + 1; // 1..12
  const day = now.getDate();

  // Christmas window
  if ((month === 12 && day >= 1) || (month === 1 && day <= 6)) return 'season-xmas';
  // Halloween window
  if ((month === 10 && day >= 24) || (month === 11 && day <= 1)) return 'season-halloween';
  // Weekend lights strip disabled (owner request, 2026-10-02).
  return '';
}
